export interface PaginatedParams {
    page: number;
    size: number;
    sortDirection: 'DESC' | 'ASC';
    sortParameter: string;
    query?: string;
}

export const ALL_ITEMS_PAGE_SIZE = 999;

export const defaultPagination: Readonly<PaginatedParams> = {
    page: 0,
    size: 10,
    sortDirection: 'DESC',
    sortParameter: 'ID',
};
